import {IFilterService} from "angular";
import {tooltipGenerator} from "./TooltipGenerator";

export function generateDefaultChartOptions(height: number,
                                            $filter: IFilterService,
                                            priceSteps: Array<any>,
                                            points: boolean) {
    return {
        chart: {
            type: "lineChart",
            height,
            margin: {
                top: 20,
                right: 20,
                bottom: 40,
                left: 55
            },
            x(d: any) {
                return d.x;
            },
            y(d: any) {
                return d.y;
            },
            useInteractiveGuideline: true,
            interactiveLayer: {
                tooltip: {
                    contentGenerator: tooltipGenerator($filter, priceSteps, points)
                }
            },
            dispatch: {},
            xAxis: {
                axisLabel: "Price Change",
                tickFormat(d: number) {
                    const steps = (priceSteps.length - 1) / 2;

                    const index = d + steps;
                    if (points) {
                        return d3.format(",.01f")(priceSteps[index]);
                    } else {
                        return d3.format(",.03f")(priceSteps[index]);
                    }
                }
            },
            yAxis: {
                axisLabel: "Payoff ($)",
                tickFormat(d: number) {
                    return d3.format(",f")(d);
                },
                axisLabelDistance: -10
            }
        }
    };
}
